import { render, staticRenderFns } from "./MaskReportScreen.vue?vue&type=template&id=2d3ca90d"
import script from "./MaskReportScreen.vue?vue&type=script&lang=js"
export * from "./MaskReportScreen.vue?vue&type=script&lang=js"
import style0 from "./MaskReportScreen.vue?vue&type=style&index=0&id=2d3ca90d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports